// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DeviceControlMessage, unionToDeviceControlMessage, unionListToDeviceControlMessage } from './device-control-message';
import { ElevatorControlMessage, ElevatorControlMessageT, verifyElevatorControlMessage } from './elevator-control-message';
import { EscalatorControlMessage, EscalatorControlMessageT, verifyEscalatorControlMessage } from './escalator-control-message';


export class ControlMessage implements flatbuffers.IUnpackableObject<ControlMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ControlMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsControlMessage(bb:flatbuffers.ByteBuffer, obj?:ControlMessage):ControlMessage {
  return (obj || new ControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsControlMessage(bb:flatbuffers.ByteBuffer, obj?:ControlMessage):ControlMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

controlType():DeviceControlMessage {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceControlMessage.NONE;
}

control<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startControlMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addControlType(builder:flatbuffers.Builder, controlType:DeviceControlMessage) {
  builder.addFieldInt8(0, controlType, DeviceControlMessage.NONE);
}

static addControl(builder:flatbuffers.Builder, controlOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, controlOffset, 0);
}

static endControlMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // control
  return offset;
}

static createControlMessage(builder:flatbuffers.Builder, controlType:DeviceControlMessage, controlOffset:flatbuffers.Offset):flatbuffers.Offset {
  ControlMessage.startControlMessage(builder);
  ControlMessage.addControlType(builder, controlType);
  ControlMessage.addControl(builder, controlOffset);
  return ControlMessage.endControlMessage(builder);
}

unpack(): ControlMessageT {
  return new ControlMessageT(
    this.controlType(),
    (() => {
      const temp = unionToDeviceControlMessage(this.controlType(), this.control.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ControlMessageT): void {
  _o.controlType = this.controlType();
  _o.control = (() => {
      const temp = unionToDeviceControlMessage(this.controlType(), this.control.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}



unpackFields(...fields: string[]): ControlMessageT {
  const t = new ControlMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('control_type')) {
    t.controlType = this.controlType();
  }
  if (fieldSet.has('control')) {
    t.control = (() => {
      const temp = unionToDeviceControlMessage(this.controlType(), this.control.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  }
  return t;
}
}

export class ControlMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public controlType: DeviceControlMessage = DeviceControlMessage.NONE,
  public control: ElevatorControlMessageT|EscalatorControlMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.control === null || this.control === undefined) {
    throw new Error('Required field "control" is not set');
  }
  const control = builder.createObjectOffset(this.control);

  return ControlMessage.createControlMessage(builder,
    this.controlType,
    control
  );
}

clone(): ControlMessageT {
  const obj = new ControlMessageT();
  obj.controlType = this.controlType;
  obj.control = this.control !== null && typeof (this.control as any).clone === 'function' ? (this.control as any).clone() : this.control;
  return obj;
}

equals(other: ControlMessageT): boolean {
  if (this.controlType !== other.controlType) return false;
  if (this.control !== null && other.control !== null) {
    if (typeof (this.control as any).equals === 'function') {
      if (!(this.control as any).equals(other.control)) return false;
    } else if (this.control !== other.control) return false;
  } else if (this.control !== other.control) return false;
  return true;
}
}

export function verifyControlMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, 'control');
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorControlMessage
            { const o = verifier.readInt32(pos); verifyElevatorControlMessage(verifier, pos + o); }
            break;
          case 2: // EscalatorControlMessage
            { const o = verifier.readInt32(pos); verifyEscalatorControlMessage(verifier, pos + o); }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, 'control');
  } finally {
    verifier.popDepth();
  }
}
